import { PreloaderHandlerInterface } from './webglLoadingHandler';
import { PreloaderScreen } from '../webgl/preloaderScreen';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let preloaderTimer: any;
const TIMER_TICK = 1000;
let timeToComplete = 10000;
let ticksToComplete = timeToComplete / TIMER_TICK;
// @ts-ignore
let tickStep = 100 / ticksToComplete;
let currentTick = 1;

export class TimerWebglLoadingHandler implements PreloaderHandlerInterface {
    setTimeToComplete(time: number) {
        timeToComplete = time;
        ticksToComplete = parseInt((timeToComplete / TIMER_TICK).toFixed(0)) || 1;
        tickStep = parseInt((100 / ticksToComplete).toFixed(0));
    }

    onCompatibilityCheckFailed(): void {
        return undefined;
    }

    onCompileProgressChange(_compileProgressShare: number): void {
        return undefined;
    }

    onClientLoadingProgressChanged(_clientLoadingPercent: number): void {
        return undefined;
    }

    onPreStart(initialPercents: number): void {
        const percentsToLoad = 100 - initialPercents;
        const tickStep = percentsToLoad / ticksToComplete;
        preloaderTimer = setInterval(() => {
            let percent = initialPercents + currentTick * tickStep + Math.random() * 3;

            if (percent > 100) {
                percent = 100;
            }

            PreloaderScreen.getInstance().setLoadingProgress(percent);
            currentTick += 1;

            if (currentTick === ticksToComplete + 1) {
                clearInterval(preloaderTimer);
            }
        }, TIMER_TICK);
    }
}
